import type {
  RoomJoinRequestResponse,
  RoomJoinRequestsResponse,
  RoomRequestListQuery,
} from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export type RoomRequestAnswer = 'accept' | 'decline'

export const roomRequestsApi = {
  async list(
    businessId: string,
    eventId: string,
    status: RoomRequestListQuery['status'],
  ): Promise<RoomJoinRequestsResponse> {
    const res = await api.api.businesses[':businessId'].events[':id'].requests.$get({
      param: { businessId, id: eventId },
      query: { status },
    })
    return unwrap<RoomJoinRequestsResponse>(res)
  },

  async answer(
    businessId: string,
    eventId: string,
    requestId: string,
    answer: RoomRequestAnswer,
  ): Promise<RoomJoinRequestResponse> {
    const route = api.api.businesses[':businessId'].events[':id'].requests[':requestId']
    const param = { businessId, id: eventId, requestId }
    const res =
      answer === 'accept'
        ? await route.accept.$post({ param })
        : await route.decline.$post({ param })
    return unwrap<RoomJoinRequestResponse>(res)
  },
}
